export function timeAgo(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  const s = Math.floor((Date.now() - d.getTime()) / 1000);
  if (s < 0) return "à l'instant";
  if (s < 60) return `il y a ${s}s`;
  if (s < 3600) return `il y a ${Math.floor(s / 60)}min`;
  if (s < 86400) return `il y a ${Math.floor(s / 3600)}h`;
  return d.toLocaleDateString("fr-FR");
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString("fr-FR", { hour12: false });
}

export function num(v, digits = 1) {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return Number(v).toFixed(digits);
}

export function batteryColor(b) {
  if (b == null) return "#525252";
  if (b < 20) return "#EF4444";
  if (b < 35) return "#F59E0B";
  return "#22C55E";
}

// TELEMETRY.INDEPENDENT.FIELDS.1 — batterie / position ACTUELLES vs DERNIÈRES CONNUES. Jamais 0 % ni 0,0 fabriqués.
const _fin = (v) => typeof v === "number" && Number.isFinite(v);
// Valeur courante : numérique ET (état absent = source ancienne, ou état explicitement "valid").
const _cur = (v, state) => _fin(v) && (state == null || state === "valid");
export function batteryShort(d) {
  return _cur(d?.battery, d?.battery_state) ? `${Math.round(d.battery)}%` : "—";
}
export function batteryText(d) {
  if (_cur(d?.battery, d?.battery_state)) return `${Math.round(d.battery)}%`;
  if (d?.battery_state === "stale" && _fin(d?.last_known_battery)) return `PÉRIMÉE (dern. ${Math.round(d.last_known_battery)}%)`;
  return "INDISPONIBLE";
}
export function positionText(d, digits = 5) {
  if (_cur(d?.lat, d?.position_state) && _fin(d?.lng)) return `${d.lat.toFixed(digits)}, ${d.lng.toFixed(digits)}`;
  if (d?.position_state === "stale" && _fin(d?.last_known_lat) && _fin(d?.last_known_lng))
    return `PÉRIMÉE (dern. ${d.last_known_lat.toFixed(digits)}, ${d.last_known_lng.toFixed(digits)})`;
  return "INDISPONIBLE";
}

export function statusColor(d) {
  if (!d || d.status !== "online") return "#525252";
  // Batterie inconnue : jamais présumée saine (orange), jamais 100 % implicite.
  if (typeof d.battery !== "number" || !Number.isFinite(d.battery)) return "#F59E0B";
  if (d.battery < 20) return "#EF4444";
  if (d.battery < 35) return "#F59E0B";
  return "#22C55E";
}

// A.5.3A : état GPS explicite (découplé de ONLINE/OFFLINE). Fallback compat si gps_state absent.
function _gps(d) {
  return d?.gps_state ?? (d?.gps_fix === true ? "fix" : d?.gps_fix === false ? "no_fix" : "unavailable");
}
export function gpsLabel(d) {
  const s = _gps(d);
  if (s === "fix") return "GPS OK";
  if (s === "no_fix") return "GPS NO FIX";
  return "GPS INDISPONIBLE";
}
export function gpsColor(d) {
  const s = _gps(d);
  if (s === "fix") return "#22C55E";
  if (s === "no_fix") return "#EF4444";
  return "#525252";
}

// A.5.3A : état télémétrie explicite (découplé de ONLINE/OFFLINE).
function _tele(d) {
  return d?.telemetry_state ?? (d?.telemetry_stale ? "stale" : "fresh");
}
export function telemetryLabel(d) {
  const s = _tele(d);
  if (s === "fresh") return "TÉLÉMÉTRIE OK";
  if (s === "stale") return "TÉLÉMÉTRIE PÉRIMÉE";
  return "TÉLÉMÉTRIE INDISPONIBLE";
}
export function telemetryColor(d) {
  const s = _tele(d);
  if (s === "fresh") return "#22C55E";
  if (s === "stale") return "#F59E0B";
  return "#525252";
}
